import React, { Component } from "react";
import { Icon, Row, Select } from "antd";
import debounce from "lodash/debounce";
import { PropTypes } from 'prop-types';
import { connect } from "react-redux";
import guideStarLogo from "../../../../assets/icons/GuideStar-logo.svg";
import { BottomWrapper, Box, CloseText, FilterCol, InputBox, PoweredBy, SelectBox, TabTitles } from "./styles";
import { recordError } from "../../../../utils/commonUtil";

const Option = Select.Option;

const ConfigGemini = [
  {
    title: "City",
    mode: "default",
    placeholder: "Filter by city",
    key: "city",
    options: "zipRaOptio",
    filterSet: false
  },
  {
    title: "Organization Interest Area",
    mode: "default",
    placeholder: "Filter by OIA",
    key: "oia",
    options: "zipRaOptions",
    filterSet: false
  },
  {
    title: "Employer Identification Number",
    mode: "default",
    placeholder: "Filter by EIN",
    key: "ein",
    options: "zipRaOptio",
    filterSet: false
  },
  {
    title: "State",
    mode: "default",
    placeholder: "Filter by state",
    key: "states",
    options: "stateOptions",
    filterSet: false
  },
  {
    title: "Zipcode Number",
    mode: "default",
    placeholder: "Filter by zipcode",
    key: "zipcode",
    options: "zipRaOptio",
    filterSet: false
  }
];

const zipRadius = [
  { name: "Civic", code: 10 },
  { name: "Arts & Culture", code: 20 },
  { name: "Education", code: 30 },
  { name: "Environment & Wildlife", code: 40 },
  { name: "Health", code: 50 },
  { name: "Historical", code: 60 },
  { name: "Human Services", code: 70 },
  { name: "Religion", code: 80 },
  { name: "Animal and Wildlife Protection", code: 90 },
  { name: "Other", code: 100 },
  { name: "Direct International", code: 110 }
];

const GeminiStates = [
  { name: "Alabama", code: "AL" },
  { name: "Alaska", code: "AK" },
  { name: "American Samoa", code: "AS" },
  { name: "Arizona", code: "AZ" },
  { name: "Arkansas", code: "AR" },
  { name: "Armed Forces Europe", code: "AE" },
  { name: "Armed Forces Americas", code: "AA" },
  { name: "Armed Forces Pacific", code: "AP" },
  { name: "California", code: "CA" },
  { name: "Colorado", code: "CO" },
  { name: "Connecticut", code: "CT" },
  { name: "Delaware", code: "DE" },
  { name: "District of Columbia", code: "DC" },
  { name: "Florida", code: "FL" },
  { name: "Guam", code: "GU" },
  { name: "Georgia", code: "GA" },
  { name: "Hawaii", code: "HI" },
  { name: "Idaho", code: "ID" },
  { name: "Illinois", code: "IL" },
  { name: "Indiana", code: "IN" },
  { name: "Iowa", code: "IA" },
  { name: "Kansas", code: "KS" },
  { name: "Kentucky", code: "KY" },
  { name: "Louisiana", code: "LA" },
  { name: "Maine", code: "ME" },
  { name: "Maryland", code: "MD" },
  { name: "Massachusetts", code: "MA" },
  { name: "Michigan", code: "MI" },
  { name: "Minnesota", code: "MN" },
  { name: "Mississippi", code: "MS" },
  { name: "Missouri", code: "MO" },
  { name: "Montana", code: "" },
  { name: "Nebraska", code: "NE" },
  { name: "Nevada", code: "NV" },
  { name: "New Hampshire", code: "NH" },
  { name: "New Jersey", code: "NJ" },
  { name: "New Mexico", code: "NM" },
  { name: "New York", code: "NY" },
  { name: "North Carolina", code: "NC" },
  { name: "North Dakota", code: "ND" },
  { name: "Northern Mariana Islands", code: "MP" },
  { name: "Ohio", code: "OH" },
  { name: "Oklahoma", code: "OK" },
  { name: "Oregon", code: "OR" },
  { name: "Pennsylvania", code: "PA" },
  { name: "Puerto Rico", code: "PR" },
  { name: "Palau", code: "PW" },
  { name: "Rhode Island", code: "RI" },
  { name: "South Carolina", code: "SC" },
  { name: "South Dakota", code: "SD" },
  { name: "Tennessee", code: "TN" },
  { name: "Texas", code: "TX" },
  { name: "Utah", code: "UT" },
  { name: "Vermont", code: "VT" },
  { name: "Virgin Islands", code: "VI" },
  { name: "Virginia", code: "VA" },
  { name: "Washington", code: "WA" },
  { name: "West Virginia", code: "WV" },
  { name: "Wisconsin", code: "WI" },
  { name: "Wyoming", code: "WY" }
];

const zipRaOp = [];
{
  zipRadius.map((obj, index) => {
    zipRaOp.push(
      <Option key={obj.code} value={obj.name} title={obj.name}>
        {obj.name}
      </Option>
    );
  });
}

const gemStates = [];
{
  GeminiStates.map((obj, index) => {
    gemStates.push(
      <Option key={obj.code} value={obj.name} title={obj.name}>
        {obj.name}
      </Option>
    );
  });
}

class GeminiFilter extends Component {
  constructor(props) {
    super(props);
    this.lastFetchId = 0;
    this.fetchUser = debounce(this.fetchUser, 2000);
  }

  state = {
    zipRaOptions: zipRaOp,
    stateOptions: gemStates,
    menuIsOpen: false,
    geminiFilterCount: 0,
    data: [],
    value: [],
    fetching: false,
    filterCityProps: [],
    city: "",
    oia: "",
    ein: "",
    states: "",
    zipcode: "",
    inputValueCity: "",
    inputValueEin: "",
    inputValueZipcode: "",
    oiaData: "",
    oiaCode: ""
  };

  stateChange = (value, key) => {
    if (`${key}` === "city") {
      let { city } = this.state;
      city = value.target.value;
      this.setState(
        {
          city: city,
          inputValueCity: city
        },
        () => {
          this.props.updateStateFunc(city, key);
          this.sendGeminiData();
        }
      );
    }
    if (`${key}` === "oia") {
      if (!value) {
        this.setState({ oiaCode: "" }, () => {
          this.props.updateStateFunc(this.state.oiaCode, key);
          this.sendGeminiData();
        });
      } else {
        let oiaValue = zipRadius.filter(function(item) {
          if (value === item.name) {
            return item.code;
          }
        });
        this.setState(
          {
            oiaCode: oiaValue[0].code
          },
          () => {
            this.props.updateStateFunc(oiaValue[0].code, key);
            this.sendGeminiData();
          }
        );
      }
    }
    if (`${key}` === "ein") {
      let { ein } = this.state;
      ein = value.target.value;
      this.setState(
        {
          ein: ein,
          inputValueEin: ein
        },
        () => {
          this.props.updateStateFunc(ein, key);
          this.sendGeminiData();
        }
      );
    }
    if (`${key}` === "states") {
      let { states } = this.state;
      states = value || "";
      if (!states) {
        states = "";
        this.setState(
          {
            states: states
          },
          () => {
            this.props.updateStateFunc(states, key);
            this.sendGeminiData();
          }
        );
      } else {
        let stateCode = GeminiStates.filter(function(item) {
          if (value === item.name) {
            return item.code;
          }
        });
        this.setState(
          {
            states: stateCode[0].code
          },
          () => {
            this.props.updateStateFunc(stateCode[0].code, key);
            this.sendGeminiData();
          }
        );
      }
    }
    if (`${key}` === "zipcode") {
      let { zipcode } = this.state;
      zipcode = value.target.value;
      this.setState(
        {
          zipcode: zipcode,
          inputValueZipcode: zipcode
        },
        () => {
          this.props.updateStateFunc(zipcode, key);
          this.sendGeminiData();
        }
      );
    }
  };

  sendGeminiData = () => {
    let geminiFilters = "";
    if (this.state.states !== "" && this.state.states !== undefined) {
      let stateVal = this.state.states;
      let stateCode = GeminiStates.filter(function(item) {
        if (stateVal === item.code) {
          return item.code;
        }
        if (stateVal === item.name) {
          return item.code;
        }
      });
      this.setState({ states: stateCode[0].code }, () => {
        geminiFilters = {
          city: this.state.city,
          oia: this.state.oiaCode,
          ein: this.state.ein,
          states: stateCode[0].code,
          zipcode: this.state.zipcode
        };
        this.props.geminiFilterData(geminiFilters);
      });
    } else {
      geminiFilters = {
        city: this.state.city,
        oia: this.state.oiaCode,
        ein: this.state.ein,
        states: this.state.states || "",
        zipcode: this.state.zipcode
      };
      this.props.geminiFilterData(geminiFilters);
    }
  };
  closeFunc = index => {
    try {
      this.props.closeOption(index);
    } catch (error) {
      recordError(error);
    }
  };
  fetchUser = value => {
    this.props.cityLoader();
    this.lastFetchId += 1;
    this.setState({ data: [], fetching: true }, this.postCityData(value));
  };

  handleChange = value => {
    this.setState({
      value,
      data: [],
      fetching: false
    });
  };
  handleClick = e => {
    if (this.node.contains(e.target)) {
      return;
    }
    let elem = document.querySelector(".GemPopup");
    elem.style.display = "none";
  };


  componentWillMount() {
    if (this.props.tabFilters.oia !== "") {
      let oiaVal = this.props.tabFilters.oia;
      const oiaData = zipRadius.filter(function(item) {
        if (oiaVal === item.code) {
          return item.name;
        }
      });
      this.setState({ oiaData: oiaData[0].name });
    } else {
      this.setState({ oiaData: undefined });
    }

    if (this.props.tabFilters.states) {
      let stateVal = this.props.tabFilters.states;
      const stateData = GeminiStates.filter(function(item) {
        if (stateVal === item.code) {
          return item.name;
        }
      });
      this.setState({ states: stateData[0].name });
    } else {
      this.setState({ states: undefined });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.tabFilters.oia) {
      const oiaData = zipRadius.filter(function(item) {
        if (nextProps.tabFilters.oia === item.code) {
          return item.name;
        }
      });
      this.setState({ oiaData: oiaData[0].name });
    } else {
      this.setState({ oiaData: undefined });
    }

    if (nextProps.tabFilters.states) {
      const stateData = GeminiStates.filter(function(item) {
        if (nextProps.tabFilters.states === item.code) {
          return item.name;
        }
      });
      this.setState({ states: stateData[0].name });
    } else {
      this.setState({ states: undefined });
    }

    this.setState({
      inputValueCity: nextProps.tabFilters.city,
      inputValueEin: nextProps.tabFilters.ein,
      inputValueZipcode: nextProps.tabFilters.zipcode
    });
  }
  stateFocusChange = (value, id) => {
    this.stateChange(value, id);
  };

  render() {
  const {isFull }=  this.props 
    return (
      <Box className="GemPopup" ref={node => (this.node = node)} left={95}>
        <Row gutter={16}>
          {ConfigGemini.map((obj, index) => {
            const dummystate = obj.key;
            const childrenData = obj.options;

            return (
              <FilterCol id="area" className="gutter-row" lg={{ span: 8 }}>
                <TabTitles>{obj.title} </TabTitles>
                {index === 1 ? (
                  <SelectBox
                    data-test = "index-1"
                    value={this.state.oiaData}
                    style={{ width: "100%" }}
                    allowClear={true}
                    mode={obj.mode}
                    placeholder={obj.placeholder}
                    onChange={event => this.stateChange(event, obj.key)}
                    getPopupContainer={() => document.getElementById("area")}
                    key={obj.key}
                  >
                    {this.state[childrenData]}
                  </SelectBox>
                ) : index === 3 ? (
                  <SelectBox
                  data-test = "index-3"
                    value={this.state.states}
                    allowClear={true}
                    mode={obj.mode}
                    style={{ width: "100%" }}
                    placeholder={obj.placeholder}
                    onChange={event => this.stateChange(event, obj.key)}
                    getPopupContainer={() => document.getElementById("area")}
                    key={obj.key}
                  >
                    {this.state[childrenData]}
                  </SelectBox>
                ) : index === 0 ? (
                  <InputBox
                  data-test = "input-1"
                    value={this.props.tabFilters[dummystate]}
                    mode={obj.mode}
                    placeholder={obj.placeholder}
                    onChange={event => this.stateFocusChange(event, obj.key)}
                    key={obj.key}
                  >
                  </InputBox>
                ) : index === 2 ? (
                  <InputBox
                  data-test = "input-2"
                    value={this.props.tabFilters[dummystate]}
                    mode={obj.mode}
                    placeholder={obj.placeholder}
                    onChange={event => this.stateFocusChange(event, obj.key)}
                    key={obj.key}
                  ></InputBox>
                ) : (
                  <InputBox
                  data-test = "input-3"
                    value={this.props.tabFilters[dummystate]}
                    mode={obj.mode}
                    placeholder={obj.placeholder}
                    onChange={event => this.stateFocusChange(event, obj.key)}
                    key={obj.key}
                    type="number"
                  ></InputBox>
                )}
              </FilterCol>
            );
          })}
        </Row>{" "}
        <Row>
          <BottomWrapper>
            <PoweredBy>
              <span>Powered By</span>
              <img src={guideStarLogo} alt="Vangaurd" />
            </PoweredBy>
            <CloseText
              key="closeText"
              data-test="close-Text"
              onClick={index => this.closeFunc(this.props.index)}
            >
              Close <Icon type="close" />
            </CloseText>
          </BottomWrapper>
        </Row>
      </Box>
    );
  }
}

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => ({
});

GeminiFilter.propTypes = {
  closeOption: PropTypes.func,
  fromPage: PropTypes.string,
  geminiFilterData: PropTypes.func,
  index: PropTypes.number,
  isFull: PropTypes.bool,
  sliderStatus: PropTypes.func,
  tabFilters: PropTypes.shape({
    city: PropTypes.string,
    ein: PropTypes.string,
    oia: PropTypes.string,
    state: PropTypes.string,
    zipcode: PropTypes.string,
  }),
  updateStateFunc: PropTypes.func,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GeminiFilter);
